"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStepLabel = getStepLabel;
exports.getStepCompletionEventLabel = getStepCompletionEventLabel;
exports.translateContentType = translateContentType;
exports.getStepChildKey = getStepChildKey;

var _constants = require("./constants");

/**
 * Returns the user-friendly name of a step, deriving it from the name of its parent
 * Journey and type if necessary.
 *
 * @param stepId
 * @param steps
 * @param includeType
 * @returns {*}
 */

function getStepLabel(stepId, steps) {
  var includeType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var step = steps[stepId];

  if (step) {
    if (step.parentId) {
      var journey = steps[step.parentId];
      if (journey && journey.steps) {
        var journeyStepAttrs = journey.steps[stepId];
        if (journeyStepAttrs) {
          var stepTypeLabel = _constants.STEP_TYPES[step.type].label;
          var journeyName = journey.name || journey.id;
          return includeType ? journeyName + " | Step " + (journeyStepAttrs.index + 1) + " (" + stepTypeLabel + " Group)" : journeyName;
        }
      }
    }

    if (step.name) {
      return step.name;
    }
  }

  return stepId;
}

/**
 * Modals & Slideouts must only be "seen" to be considered "completed"
 * by Dynamo/The API, while all other patterns require each step to complete.
 *
 * Thus, attempt to ensure that we don't use the wrong term.
 *
 * @param step
 * @returns {string}
 */

function getStepCompletionEventLabel(step) {
  return step && step.stepType && [_constants.STEP_TYPE_IDS.MODAL, _constants.STEP_TYPE_IDS.SLIDEOUT].includes(step.stepType) ? "seen" : "completed";
}

function translateContentType(contentType) {
  return _constants.CONTENT_TYPES[contentType.toLowerCase()];
}

function getStepChildKey(contentType) {
  return _constants.STEP_CHILD_KEYS[translateContentType(contentType)];
}